(function () {
  var STORAGE_KEY = 'wo-jumua-times-v1';
  var CLOSE_DURATION_MIN = 45; // fermeture Dhuhr -> Dhuhr + 45 min. Ajuster ici si besoin.
  // Coordonnées de la mosquée Omar Ibn Khattab (Bagneux, 92) : leur Jumu'a suit
  // exactement l'heure de Dhuhr calculée pour ce point précis (vérifié via mawaqit.net).
  var API_URL = 'https://api.aladhan.com/v1/timings?latitude=48.7959109&longitude=2.316573&method=12';

  function parisNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
  }

  function todayKey(d) {
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  function getCachedDhuhr(dateKey) {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (data.date !== dateKey) return null;
      return data.dhuhrMinutes;
    } catch (e) {
      return null;
    }
  }

  function setCachedDhuhr(dateKey, minutes) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ date: dateKey, dhuhrMinutes: minutes }));
    } catch (e) {}
  }

  function parseHHMMtoMinutes(hhmm) {
    var clean = hhmm.split(' ')[0];
    var parts = clean.split(':');
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  var closedNow = false;

  var STYLE_ID = 'wo-jumua-style';
  var SELECTORS = 'button[name="add"], button[name="checkout"], #checkout, #CartDrawer-Checkout';

  // Règle CSS : s'applique en continu à tout bouton correspondant, y compris ceux
  // insérés/recréés après coup par des widgets tiers (ex. carrousel upsell "Faites-en
  // un kit" qui régénère ses boutons en boucle). Contrairement à une propriété JS
  // (disabled = true), une règle CSS n'a pas besoin d'être réappliquée à chaque
  // insertion : le navigateur la fait correspondre en continu, donc pas de course
  // possible entre notre script et un re-rendu du widget.
  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      'body.wo-jumua-closed ' + SELECTORS.split(', ').join(', body.wo-jumua-closed ') + ' {' +
      'pointer-events:none!important;opacity:.5;cursor:not-allowed;}';
    document.head.appendChild(style);
  }

  // Complément : positionne aussi l'attribut natif disabled sur les boutons présents
  // à l'instant T (sémantique native pour lecteurs d'écran, désactive aussi le clavier
  // que pointer-events ne couvre pas). Le blocage réel, lui, ne dépend pas de ce passage
  // grâce au filet de sécurité sur 'submit' plus bas.
  function reapplyButtonState() {
    ensureStyle();
    document.body.classList.toggle('wo-jumua-closed', closedNow);
    document.querySelectorAll(SELECTORS).forEach(function (btn) {
      btn.disabled = closedNow;
    });
  }

  function updateBanner(reopenLabel) {
    var banner = document.getElementById('wo-jumua-banner');
    if (closedNow) {
      if (!banner) {
        banner = document.createElement('div');
        banner.id = 'wo-jumua-banner';
        banner.setAttribute('role', 'status');
        banner.style.cssText =
          'position:sticky;top:0;z-index:9999;background:#111;color:#fff;text-align:center;' +
          'padding:10px 16px;font-size:14px;line-height:1.4;';
        document.body.insertBefore(banner, document.body.firstChild);
      }
      banner.textContent =
        'Boutique temporairement fermée pour maintenance. Réouverture vers ' +
        reopenLabel +
        '. Vous pouvez continuer à consulter le site.';
      banner.style.display = 'block';
    } else if (banner) {
      banner.style.display = 'none';
    }
  }

  // Filet de sécurité : bloque toute soumission de formulaire add-to-cart/checkout
  // même si un bouton n'a pas (encore) reçu l'état disabled — couvre le délai entre
  // l'insertion d'un bouton dans le DOM et le passage du MutationObserver/tick.
  document.addEventListener(
    'submit',
    function (e) {
      if (!closedNow) return;
      var form = e.target;
      if (!form) return;
      var isAddForm = form.querySelector('button[name="add"], input[name="add"]');
      var isCheckoutForm =
        form.querySelector('button[name="checkout"], input[name="checkout"]') ||
        form.getAttribute('action') === '/cart';
      if (isAddForm || isCheckoutForm) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  var mutationDebounce = null;
  function scheduleReapply() {
    if (mutationDebounce) return;
    mutationDebounce = setTimeout(function () {
      mutationDebounce = null;
      reapplyButtonState();
    }, 200);
  }

  var observerStarted = false;
  function startObserver() {
    if (observerStarted) return;
    observerStarted = true;
    var mo = new MutationObserver(scheduleReapply);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function tick(dhuhrMinutes) {
    var now = parisNow();
    if (now.getDay() !== 5) {
      closedNow = false;
      reapplyButtonState();
      updateBanner(null);
      return;
    }
    var nowMinutes = now.getHours() * 60 + now.getMinutes();
    var closeStart = dhuhrMinutes;
    var closeEnd = dhuhrMinutes + CLOSE_DURATION_MIN;
    closedNow = nowMinutes >= closeStart && nowMinutes < closeEnd;
    var reopenLabel = pad(Math.floor(closeEnd / 60)) + 'h' + pad(closeEnd % 60);
    reapplyButtonState();
    updateBanner(reopenLabel);
  }

  function init() {
    var now = parisNow();
    if (now.getDay() !== 5) return; // pas vendredi : aucun appel API, rien à faire

    var dateKey = todayKey(now);
    var cached = getCachedDhuhr(dateKey);

    function start(dhuhrMinutes) {
      tick(dhuhrMinutes);
      startObserver();
      setInterval(function () {
        tick(dhuhrMinutes);
      }, 30000);
    }

    if (cached !== null) {
      start(cached);
      return;
    }

    fetch(API_URL)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var minutes = parseHHMMtoMinutes(data.data.timings.Dhuhr);
        setCachedDhuhr(dateKey, minutes);
        start(minutes);
      })
      .catch(function () {
        // API indisponible : on ne bloque pas les ventes par sécurité plutôt que de risquer
        // une fermeture mal calculée toute la journée.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
